import React, { useEffect, useState, useRef } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Spin } from 'antd';
import CreateBotModal from './modals/create-bot';
import ConnectToRemote from "./modals/connect-to-remote";
import { useNavigate } from "react-router-dom";
import { useAppContext, APP_ACTIONS, changeHostIP, WS, userId } from "../../context/appContext";
import bot from "../common/img/bot.png"
import fetchProfiles from '../common/helpers/fetch-profiles';
import createProfile from "../common/helpers/create-profile";
import createBot from "../common/helpers/create-bot";
import fetchBots from "../common/helpers/fetch-bots";
import updateProfile from "../common/helpers/update-profile";
import fetchUnprocessedOrders from "../common/helpers/fetch-unprocessed-orders";
import updateBot from "../common/helpers/update-bot";
import deleteBot from "../common/helpers/delete-bot";
import createOrders from '../common/helpers/create-orders';
import cancelOrder from '../common/helpers/cancel-order';
import cancelOrderById from "../common/helpers/cancel-order-by-id";
import createUnprocessedOrders from "../common/helpers/create-unprocessed-orders";
import createUnprocessedAccumulators from "../common/helpers/create-unprocessed-accumulators";
import fetchUserSettings from "../common/helpers/fetch-user-settings";
import Advanced from "../Advanced/advanced";
import { PlayCircleOutlined } from '@ant-design/icons';
const { Option } = Select;
const { TabPane } = Tabs;

const key = 'order_place';
const tableHeaderStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", paddingLeft: 20 }
const tableRowStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", paddingLeft: 20 }

const botType = {
    'marketmaker': 'Market Maker',
    'accumulator': 'Accumulator',
    'triangular': 'Triangular',
}

const Home = ({ changeRemoteHost, connectionLoading, hasAuth, restartData }) => {
    const {
        state: { bots, strategies, user },
        dispatch,
    } = useAppContext();

    const firstRender = useRef(true);

    // let navigate = useNavigate();
    const [displayCreateBot, setDisplayCreateBot] = useState(false);
    const [displayAdvancedSection, setDisplayAdvancedSection] = useState(false);
    const [displayConnectHost, setDisplayConnectHost] = useState(false);
    const [selectedBot, setSelectedBot] = useState();
    const [updateSelectedBot, setUpdateSelectedBot] = useState();
    const [triggerRefresh, setTriggerRefresh] = useState(false);
    const [loading, setLoading] = useState(false);

    const [orders, setOrders] = useState([]);
    const [botStates, setBotStates] = useState({});

    const [disableAction, setDisableAction] = useState(false);
    const [serverUnresponsive, setServerUnresponsive] = useState(false);
    const [displayWarning, setDisplayWarning] = useState(false);
    const [deleteBotId, setDeleteBotId] = useState();
    const [remoteHost, setRemoteHost] = useState(false);

    const [accumulators, setAccumulators] = useState([]);

    const [previousOrderState, setPreviousOrderState] = useState([]);

    // useEffect(() => {
    //     console.log({
    //         orders
    //     })
    // }, [orders])

    useEffect(() => {

        const client = new WebSocket(WS);
        let hearbeat;
        client.onmessage = ({ data }) => {

            setDisableAction(false);
            const parsedData = JSON.parse(data);
            console.log({ SOCKET: parsedData })
            if (parsedData.socketId) {
               
                client.send(userId)

                hearbeat = setInterval(() => {
                    client.send('{"kind":"pong"}');
                }, 30000)
            }

            if (parsedData.message === 'order_create') {
                console.log({ parsedData })
                if (parsedData.error) {
                    message.destroy({ content: parsedData.error, key: 'error' });
                    message.destroy(key);
                    // message.error({ content: parsedData.error, key: 'error', duration: 4 });

                    dispatch({
                        type: APP_ACTIONS.SET_BOT_LOGS_ERROR,
                        payload: { bot_id: parsedData?.order?.bot_id, log:  <div style={{color:"#c11919", fontWeight:"bold", overflow:"hidden", textOverflow:"ellipsis"}}>{parsedData?.order?.symbol} {parsedData.error}</div> },
                    })
                }
                setOrders(previousState => {
                    let newOrders = [...previousState]
                    newOrders.forEach(order => {
                        if (order.id === parsedData.order.id) {
                            order.logs.forEach(log => {
                                if (log.order_status === 'open') {
                                    log.order_status = 'canceled'
                                    cancelOrderById({ bot_id: order?.bot_id, order_id: log.order_id, symbol: log.symbol })
                                }
                            })
                            order.logs.push(parsedData.order)
                            console.log({ logs: order.logs })
                            if (order.logs.length > 5) order.logs.shift();
                        }
                    })
                    return newOrders;
                })

                if (!parsedData.error) {
                    // if (orders.length == 0) {
                    // message.success({ content: 'Orders Placed!', key, duration: 2 });
                    // }
                    message.destroy(key);
                    dispatch({
                        type: APP_ACTIONS.SET_BOT_LOGS_SUCCESS,
                        payload: { bot_id: parsedData?.order?.bot_id, log: <div style={{color:"green", fontWeight:"bold", textOverflow:"ellipsis", overFlow:"hidden"}}>Order Created, {parsedData?.order?.symbol}, Size: {parsedData?.order?.size}, Price: {parsedData?.order?.order_price}, {parsedData?.order?.side}</div>  },
                    })

                }
            }
            else if (parsedData.message === 'order_cancel') {

                setOrders(previousState => {

                    let newOrders = [...previousState]
                    newOrders.forEach(order => {
                        if (order.id === parsedData.order_id) {
                            order.logs.forEach(log => {
                                if (log.id === parsedData.order_id && log.order_id === parsedData.order_key) {

                                    log.order_status = 'canceled';
                                }
                            })
                        }
                    })
                    return newOrders;
                })
            }
            else if (parsedData.message === 'trade_success') {
                if (parsedData.isRebalance) {
                    if (parsedData.transactionHash) {
                        openNotificationWithIcon('success', `Transaction is complete`, `Transaction Hash: ${parsedData.transactionHash}`);
                    } else {
                        dispatch({
                            type: APP_ACTIONS.SET_BOT_LOGS_SUCCESS,
                            payload: { bot_id: parsedData?.order?.bot_id, log: <div style={{color:"#38761d", fontWeight:"bold", textOverflow:"ellipsis", overFlow:"hidden"}}>Success, Rebalance order filled, Order Id: {parsedData?.trade?.order} Symbol: {parsedData?.trade?.symbol} Side: {parsedData?.trade?.side} Size: {parsedData?.trade?.amount} Price: {parsedData?.trade?.price}</div>  },
                        })
                        // openNotificationWithIcon('success', `rebalancing order filled`, `order id: ${parsedData.trade.order}`);
                    }
                } else {

                    setOrders(previousState => {
                        let newOrders = [...previousState]
                        newOrders.forEach(order => {
                            if (order.id === parsedData.id) {
                                order.logs.forEach(log => {
                                    if (log.order_id === parsedData.trade.order) {
                                        log.order_status = 'filled';
                                    }
                                })
                            }
                        })
                        return newOrders;
                    })
                }
            }
            else if (parsedData.message === 'trade_success_partial') {
                setOrders(previousState => {
                    let newOrders = [...previousState]
                    newOrders.forEach(order => {
                        if (order.id === parsedData.id) {
                            order.logs.forEach(log => {
                                if (log.order_id === parsedData.trade.order) {
                                    log.remaining = (parseFloat(log?.remaining) || parseFloat(log?.size)) - parseFloat(parsedData?.trade?.amount);
                                }
                            })
                        }
                    })
                    return newOrders;
                })
            }
            else if (parsedData.message === 'rebalance_order_create') {
                // there is no id, use order_id
                if (parsedData.error) {
                    message.destroy({ content: parsedData.error, key: 'error' });
                    message.destroy(key);
                    // message.error({ content: parsedData.error, key: 'error', duration: 4 });

                    dispatch({
                        type: APP_ACTIONS.SET_BOT_LOGS_ERROR,
                        payload: { bot_id: parsedData?.order?.bot_id, log: <div style={{color:"#c11919", fontWeight:"bold", overflow:"hidden", textOverflow:"ellipsis"}}>{parsedData?.order?.symbol} {parsedData.error}</div> },
                    })
                }
            }
            else if (parsedData.message === 'unknown_order_exists') {
                openNotificationWithIcon('warning', `unknown order canceled`, `order id: ${parsedData?.order?.order_id}`);

                if (parsedData?.order?.order_id) {
                    setOrders(previousState => {
                        let newOrders = [...previousState]
                        newOrders.forEach(order => {
                            if (order.id === parsedData.order.id) {
                                order.logs.forEach(log => {
                                    if (log.id === parsedData.order.id && log.order_id === parsedData.order.order_id) {
                                        log.order_status = 'canceled';
                                    }
                                })
                            }
                        })
                        return newOrders;
                    })
                }

            }
            else if (parsedData.message === 'unknown_order_cancel') {
                openNotificationWithIcon('warning', `unknown order canceled`, `order id: ${parsedData?.order?.order_id}`);

                if (parsedData?.order?.order_id) {
                    setOrders(previousState => {
                        let newOrders = [...previousState]
                        newOrders.forEach(order => {
                            if (order.id === parsedData.order.id) {
                                order.logs.forEach(log => {
                                    if (log.id === parsedData.order.id && log.order_id === parsedData.order.order_id) {
                                        log.order_status = 'canceled';
                                    }
                                })
                            }
                        })
                        return newOrders;
                    })
                }
            }
            else if (parsedData.message === 'accumulate_order_cancel') {
                console.log({ accumulate_order_cancel: parsedData })

                setOrders(previousState => {
                    let newOrders = [...previousState]
                    newOrders.forEach(order => {
                        order.logs.forEach(log => {
                            if (log.order_id === parsedData.order_key) {
                                log.order_status = 'canceled -accumulated';

                                const clone = Object.assign({}, log);
                                createOrders([clone])


                                setTimeout(() => {
                                    setAccumulators(previousState => {
                                        let newOrders = [...previousState]
                                        newOrders.forEach(order => {
                                            if (order.symbol === parsedData.symbol) {
                                                order.logs.forEach(log => {
                                                    if (log.status === 'open') {
                                                        log.status = 'canceled';
                                                        cancelOrderById({ bot_id: order?.bot_id, order_id: log.id, symbol: log.symbol })
                                                    }
                                                })
                                            }
                                        })
                                        return newOrders;
                                    })
                                }, 2000)

                            }
                        })
                    })
                    return newOrders;
                })

            }
            else if (parsedData.message === 'accumulate_order_create') {

                setAccumulators(previousState => {
                    let newOrders = [...previousState]
                    newOrders.forEach(order => {
                        if (order.id === parsedData.id) {
                            if (order?.logs?.[order.logs.length - 1]) {
                                order.logs[order.logs.length - 1].status = 'canceled'
                            }
                            order.logs.push(parsedData.order)
                            if (order.logs.length > 5) order.logs.shift();
                        }
                    })
                    return newOrders;
                })

                if (!parsedData.error) {
                    // if (orders.length == 0) {
                    // message.success({ content: 'Orders accumulated!', key, duration: 2 });

                    dispatch({
                        type: APP_ACTIONS.SET_BOT_LOGS_SUCCESS,
                        payload: { bot_id: parsedData?.order?.bot_id, log: <div style={{color:"green", fontWeight:"bold",  textOverflow:"ellipsis", overFlow:"hidden"}}>Order accumulated, Created order:, {parsedData?.order?.symbol}, Size: {parsedData?.order?.size}, Price: {parsedData?.order?.price}, {parsedData?.order?.side}</div>  },
                    })
                    
                    // }
                }
            }
            else if (parsedData.message === 'new_unhandled_order') {
                dispatch({
                    type: APP_ACTIONS.SET_EDGE_CASE_ALERT,
                    payload: { notificationAlert: true, bot_id: parsedData.bot_id },
                })
            }
            else if (parsedData.message === 'bot_paused') {
                // message.warning({ content: "Exchange disconnection occured and failed to connect to it after too many retries, Strategies put on temporary pause until the next successful connection to the exchange.", key: "botPause", duration: 0 });
                dispatch({
                    type: APP_ACTIONS.SET_BOT_LOGS_WARNING,
                    payload: { bot_id: parsedData?.bot_id, log: <div style={{color:"#FF9934", fontWeight:"bold",  textOverflow:"ellipsis", overFlow:"hidden"}}>Exchange disconnection occured and failed to connect to it after too many retries, Strategies put on temporary pause until the next successful connection to the exchange.</div> },
                })
                setOrders(previousState => {
                    let newOrders = [...previousState]
                    newOrders.forEach(order => {
                        if (order.bot_id == parsedData.bot_id) {
                            order.logs.forEach(log => {
                                if (log.order_status === 'open') {
                                    log.order_status = 'paused';
                                }
                            })
                        }
                    })
                    return newOrders;
                })
            }
            else if (parsedData.message === 'bot_unpaused') {
                message.destroy("botPause");
                dispatch({
                    type: APP_ACTIONS.SET_BOT_LOGS_WARNING,
                    payload: { bot_id: parsedData?.bot_id, log: 'Bot Restarting...' },
                })
            }
            else if (parsedData.message === 'error') {
                console.log({ ERROR: parsedData.error });
                message.destroy({ content: parsedData.error, key: 'error' });
                message.destroy(key);
                // message.error({ content: parsedData.error, key: 'error', duration: 4 });

                dispatch({
                    type: APP_ACTIONS.SET_BOT_LOGS_ERROR,
                    payload: { bot_id: parsedData?.order?.bot_id, log: <div style={{color:"#c11919", fontWeight:"bold", overflow:"hidden", textOverflow:"ellipsis"}}>{parsedData?.order?.symbol} {parsedData.error}</div> },
                })
            }

            else if (parsedData.message === 'command_start_bot') {
                // startBot(parsedData.botId);
                dispatch({
                    type: APP_ACTIONS.SET_BOT_STRATEGIES,
                    payload: { id: parsedData.botId, botState: 'play' },
                })
            }
            else if (parsedData.message === 'command_stop_bot') {
                // stopBot(parsedData.botId);
                dispatch({
                    type: APP_ACTIONS.SET_BOT_STRATEGIES,
                    payload: { id: parsedData.botId, botState: 'stop' },
                })
                setOrders(previousState => {
                    let newOrders = [...previousState]
                    newOrders.filter(order => order?.bot_id === parsedData.botId).forEach(order => {
                        order.expanded = false;
                        order.logs = [];
                    })
                    return newOrders;
                })
            }
            else if (parsedData.message === 'command_restart_bot') {
                // restartBot(parsedData.botId);
                dispatch({
                    type: APP_ACTIONS.SET_BOT_STRATEGIES,
                    payload: { id: parsedData.botId, botState: 'play' },
                })
            }
            else if (parsedData.message === 'command_conversion_bot') {

                // if(strategies?.find(strategy => strategy.id === parsedData?.botId)?.botState == 'play'){
                dispatch({
                    type: APP_ACTIONS.SET_BOT_STRATEGIES,
                    payload: { id: parsedData.botId, botState: 'play' },
                })
                // }
             
                setOrders(previousState => {
                    let newOrders = [...previousState]
                    newOrders.filter(order => order?.bot_id === parsedData.botId).forEach(order => {
                        order.expanded = false;
                        order.paused = false;
                        order.logs = [];
                        order.conversion = parsedData.conversion;
                    })
                    return newOrders;
                })
                // applyConversionToBot(parsedData.botId, parsedData.conversion);
            }
        }

        client.onclose = () => {
            clearInterval(hearbeat);
            setServerUnresponsive(true);
        }
        // setWsHeartbeat(client, '{"kind":"ping"}');
        return () => {
            // stopPlay();
            client.close();
        }
    }, [changeRemoteHost])




    // useEffect(() => {
    //     // const data = JSON.parse(localStorage.getItem(`orders`))
    //     // if (data) {
    //     //     let newArr = [...data.strategies];
    //     //     newArr.forEach(order => {
    //     //         order.logs = [];
    //     //         order.saved = true;
    //     //         order.expanded = false;
    //     //     })
    //     //     setOrders(newArr);
    //     // }

    //     const accumulatorData = JSON.parse(localStorage.getItem(`accumulators`))
    //     if (accumulatorData) {
    //         accumulatorData.forEach(accumulator => {
    //             accumulator.logs = [];
    //             accumulator.saved = true;
    //             accumulator.expanded = false;
    //         })
    //         setAccumulators(accumulatorData);
    //     }
    // }, [])


    useEffect(() => {
        // const data = JSON.parse(localStorage.getItem(`orders`))
        fetchUnprocessedOrders().then(res => {
            if (Array.isArray(res)) {

                let orders = [];
                for (let bot of res) {
                    if (bot?.strategies?.data) {
                        orders = [...orders, ...bot.strategies.data];
                    }
                }

                orders.forEach(order => {
                    order.logs = [];
                    order.saved = true;
                    order.expanded = false;
                })
                setOrders(orders);

                let accumulators = [];
                for (let bot of res) {
                    if (bot?.accumulators?.data) {
                        accumulators = [...accumulators, ...bot.accumulators.data];
                    }
                }

                accumulators.forEach(order => {
                    order.logs = [];
                    order.saved = true;
                    order.expanded = false;
                })
                setAccumulators(accumulators);
            }
        })
    }, [changeRemoteHost])

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
        } else {
            fetchUnprocessedOrders().then(res => {
                if (Array.isArray(res)) {
                
                    let orders = [];
                    for (let bot of res) {
                        if (bot?.strategies?.data) {
                            orders = [...orders, ...bot.strategies.data];
                        }
                    }
                
                    orders.forEach(order => {
                        order.logs = [];
                        order.saved = true;
                        order.expanded = false;
                    })
                    setOrders(orders);
                
                    let accumulators = [];
                    for (let bot of res) {
                        if (bot?.accumulators?.data) {
                            accumulators = [...accumulators, ...bot.accumulators.data];
                        }
                    }
                
                    accumulators.forEach(order => {
                        order.logs = [];
                        order.saved = true;
                        order.expanded = false;
                    })
                    setAccumulators(accumulators);
                }
            })
        } 
    }, [restartData])

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
        } else {

            // localStorage.setItem(`orders`, JSON.stringify({ strategies: orders }));
            const stringfied = JSON.stringify(orders);
            let unProcessedOrders = JSON.parse(stringfied);


            unProcessedOrders.forEach(order => { delete order.logs; delete order.expanded; delete order.saved; })
            const stringfiedUnprocess = JSON.stringify(unProcessedOrders);
            if (previousOrderState === stringfiedUnprocess) return;
            setPreviousOrderState(stringfiedUnprocess);


            if (unProcessedOrders) {
                createUnprocessedOrders(unProcessedOrders).then((res) => {
                    // console.log({ res })
                }).catch((err) => {
                    // console.log({ err })
                })
            }

        };

    }, [orders])

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
        } else {
            // localStorage.setItem(`accumulators`, JSON.stringify(accumulators));

            let unProcessedAccumulators = JSON.parse(JSON.stringify(accumulators));

            unProcessedAccumulators.forEach(accumulator => { delete accumulator.logs; delete accumulator.expanded; delete accumulator.saved; })
            if (unProcessedAccumulators) {
                createUnprocessedAccumulators(unProcessedAccumulators).then((res) => {
                    // console.log({ res })
                }).catch((err) => {
                    // console.log({ err })
                })
            }

        };

    }, [accumulators])



    const openNotificationWithIcon = (type, message, description) => {
        notification[type]({
            message,
            description
        });
    };

    const startBot = async (botId) => {
        setBotStates(previousState => {
            const start = async () => {
                const data = previousState[botId];
                if (data === 'play') { return; }
                const orders = JSON.parse(localStorage.getItem(`orders`))?.strategies;
                if (orders.filter(order => order?.bot_id === botId).length > 0) {
                    dispatch({
                        type: APP_ACTIONS.SET_BOT_STRATEGIES,
                        payload: { id: botId, botState: 'play' },
                    })
                    openMessage();
                    const symbols = [];
                    for (const order of orders.filter(order => order?.bot_id === botId)) {
                        if (symbols.indexOf(order.symbol) === -1) {
                            symbols.push(order.symbol);
                        }
                    }
                    try {
                        await updateBot(botId, { active: true, symbols });
                        const res = await fetchBots();
                        dispatch({
                            type: APP_ACTIONS.SET_BOTS,
                            payload: res,
                        })

                        await createOrders(orders.filter(order => order?.bot_id === botId))
                    } catch (err) {
                        message.destroy(key);
                        message.error({ content: 'something went wrong', key: 'error' });
                    }
                }
            }
            start();
            return previousState;
        })


    }

    const stopBot = async (botId) => {
        setBotStates(previousState => {
            const stop = async () => {
                const data = previousState[botId];
                if (data === 'stop') { return; }

                dispatch({
                    type: APP_ACTIONS.SET_BOT_STRATEGIES,
                    payload: { id: botId, botState: 'stop' },
                })
                const orders = JSON.parse(localStorage.getItem(`orders`))?.strategies;

                message.destroy(key);
                const symbols = [];
                for (const order of orders.filter(order => order?.bot_id === botId)) {
                    if (symbols.indexOf(order.symbol) === -1) {
                        symbols.push(order.symbol);
                    }
                }

                await updateBot(botId, { active: false, symbols });

                const res = await fetchBots();
                dispatch({
                    type: APP_ACTIONS.SET_BOTS,
                    payload: res,
                })

                // this will cancell all orders
                await cancelOrder(null, false, true, botId);

                setOrders(previousState => {
                    let newOrders = [...previousState]
                    newOrders.filter(order => order?.bot_id === botId).forEach(order => {
                        order.expanded = false;
                        order.logs = [];
                    })
                    return newOrders;
                })
            }
            stop();
            return previousState;
        })



    }

    const restartBot = async (botId) => {
        await stopBot(botId);
        startBot(botId);
    }

    const applyConversionToBot = async (botId, conversion) => {
        setBotStates(previousState => {
            const applyConversion = async () => {
                const data = previousState[botId];
                if (data === 'play') {
                    dispatch({
                        type: APP_ACTIONS.SET_BOT_STRATEGIES,
                        payload: { id: botId, botState: 'stop' },
                    })
                    const orders = JSON.parse(localStorage.getItem(`orders`))?.strategies;

                    message.destroy(key);
                    const symbols = [];
                    for (const order of orders.filter(order => order?.bot_id === botId)) {
                        if (symbols.indexOf(order.symbol) === -1) {
                            symbols.push(order.symbol);
                        }
                    }

                    await updateBot(botId, { active: false, symbols });

                    const res = await fetchBots();
                    dispatch({
                        type: APP_ACTIONS.SET_BOTS,
                        payload: res,
                    })

                    // this will cancell all orders
                    await cancelOrder(null, false, true, botId);


                    setOrders(previousState => {
                        let newOrders = [...previousState]
                        newOrders.filter(order => order?.bot_id === botId).forEach(order => {
                            order.expanded = false;
                            order.logs = [];
                            order.conversion = conversion;
                        })
                        return newOrders;
                    })

                    startBot(botId);

                } else {
                    setOrders(previousState => {
                        let newOrders = [...previousState]
                        newOrders.filter(order => order?.bot_id === botId).forEach(order => {
                            order.expanded = false;
                            order.logs = [];
                            order.conversion = conversion;
                        })
                        return newOrders;
                    })
                }
            }
            applyConversion();
            return previousState;
        })
    }

    const openMessage = () => {
        message.loading({ content: 'Waiting...', key, duration: 0 });

    };

    const handleBotCreate = async (data) => {
        if (!user.is_admin) {
            if (bots.length >= user.bot_limit) {
                message.error(`bot creation limit reached`);
                return;
            }
        }

        setLoading(true);
        if (data.updateSelectedBot) {

            if (!data.isNewProfile) {
                data.newProfile.id = data.updateSelectedBot.host.id
                // await updateProfile(data.newProfile.id, data.newProfile)

                fetchProfiles().then(res => {
                    dispatch({
                        type: APP_ACTIONS.SET_PROFILES,
                        payload: res,
                    })
                })
            }

            if (data.isNewProfile) {
                data.bot.host_id = data.newProfile.id
            } else {
                data.bot.host_id = data.updateSelectedBot.host.id
            }

            updateBot(data.updateSelectedBot.id, data.bot).then((res) => {
                if (res.error) {
                    message.error(res.error)
                }
                fetchBots().then(res => {
                    setLoading(false)
                    dispatch({
                        type: APP_ACTIONS.SET_BOTS,
                        payload: res,
                    })
                })
            })

            return;
        }
        if (data.newProfile.id) {
            data.bot.host_id = data.newProfile.id
            createBot(data.bot).then((newBot) => {
                if (newBot.error) {
                    message.error(newBot.error)
                }
                fetchBots().then(res => {
                    setLoading(false);
                    dispatch({
                        type: APP_ACTIONS.SET_BOTS,
                        payload: res,
                    })
                })
            })
        } else {
            //Create Profile
            createProfile(data.newProfile).then((newProfileData) => {
                fetchProfiles().then(res => {
                    dispatch({
                        type: APP_ACTIONS.SET_PROFILES,
                        payload: res,
                    })
                    data.bot.host_id = newProfileData.id
                    createBot(data.bot).then((newBot) => {
                        if (newBot.error) {
                            message.error(newBot.error)
                        }
                        fetchBots().then(res => {
                            setLoading(false);
                            dispatch({
                                type: APP_ACTIONS.SET_BOTS,
                                payload: res,
                            })
                        })
                    })
                })
            })

        }
    }
    const handleBotDelete = async (id) => {

        setLoading(true);
        const symbols = [];
        for (const order of orders.filter(order => order?.bot_id === id)) {
            if (symbols.indexOf(order.symbol) === -1) {
                symbols.push(order.symbol);
            }
        }
        await cancelOrder(null, false, true, id);
        await updateBot(id, { active: false, symbols })

        let data = JSON.parse(localStorage.getItem(`orders`))
        if (data && data.strategies) {
            data.strategies = data.strategies.filter(order => order.bot_id !== id)
        }
        if (data) localStorage.setItem(`orders`, JSON.stringify({ strategies: data.strategies }));

        deleteBot(id).then(() => {
            fetchBots().then(res => {
                dispatch({
                    type: APP_ACTIONS.SET_BOTS,
                    payload: res,
                })
                setLoading(false);
            })
        })
    }
    useEffect(() => {
        setServerUnresponsive(false);
        setLoading(true);
        fetchBots().then(res => {
            setLoading(false);
            if (res.message) return;
            dispatch({
                type: APP_ACTIONS.SET_BOTS,
                payload: res,
            })
        }).catch(err => {
            setLoading(false);
            console.log({ err })
        })

        fetchProfiles().then(res => {
            if (res.message) return;
            dispatch({
                type: APP_ACTIONS.SET_PROFILES,
                payload: res,
            })
        })
    }, [changeRemoteHost, hasAuth])

    useEffect(() => {
        if (userId) {
            fetchUserSettings(userId).then(res => {
                dispatch({
                    type: APP_ACTIONS.SET_CUSTOM_MARKETS,
                    payload: res || [],
                })
            })
        }
    }, [userId])

    const handleConnectHost = (data) => {
        message.loading({ content: 'Waiting...', key: 'remoteHostLoading', duration: 0 });
        changeHostIP(data).then(res => {
            message.success({ content: "connected to the remote host" });
            localStorage.setItem('remote-host', data.host_ip);
            message.destroy('remoteHostLoading');
            setRemoteHost(true);
            setServerUnresponsive(false);
            setTriggerRefresh(!triggerRefresh)

        }).catch(err => {
            message.error({ content: 'error, could not connect' })
        })

        setDisplayConnectHost(false);
    }
    return (
        <>
            <Modal bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
                visible={displayWarning} footer={null} onCancel={() => { setDisplayWarning(false); }}>

                <div style={{ fontWeight: "600", color: "white" }}>
                    <svg style={{ position: "relative", top: 3 }} xmlns="http://www.w3.org/2000/svg" width="13.879" height="17.615" viewBox="0 0 19.879 23.615">
                        <path id="Path_6000" data-name="Path 6000" d="M253.724,145.963h-4.567V143.6a.723.723,0,0,0-.723-.723h-7.852a.723.723,0,0,0-.723.723v2.368h-4.567a.723.723,0,0,0-.723.723v3.091a.723.723,0,0,0,.723.723h.641v15.263a.723.723,0,0,0,.723.723h15.7a.723.723,0,0,0,.723-.723V150.5h.641a.723.723,0,0,0,.723-.723v-3.091a.724.724,0,0,0-.724-.724Zm-12.419-1.644h6.405v1.644h-6.405Zm-5.29,3.091H253v1.644H236.015Zm15.622,17.631H237.38V150.5h2.479v9.721a.723.723,0,1,0,1.446,0V150.5h2.48v9.721a.723.723,0,1,0,1.446,0V150.5h2.48v9.721a.723.723,0,1,0,1.446,0V150.5h2.48v14.54Z" transform="translate(-234.569 -142.872)" fill="#fff" />
                    </svg>
                    <span style={{ marginLeft: 5 }}>Delete Bot</span></div>
                <div style={{ color: "grey", marginTop: 20, marginBottom: 40 }}>
                    Are you sure you want to delete this bot?
                </div>


                <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                    <Button onClick={() => { setDisplayWarning(false); }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">NO</Button>
                    <Button onClick={() => {
                        handleBotDelete(deleteBotId);
                        setDisplayWarning(false);
                    }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">YES</Button>
                </div>
            </Modal>


            {displayAdvancedSection ? <Advanced selectedBot={selectedBot} orders={orders} serverUnresponsive={serverUnresponsive} disableAction={disableAction} setDisableAction={setDisableAction} setOrders={setOrders} setDisplayAdvancedSection={setDisplayAdvancedSection} setBotStates={setBotStates} accumulators={accumulators} setAccumulators={setAccumulators} /> : <>

                {displayCreateBot && <CreateBotModal displayCreateBot={displayCreateBot} setDisplayCreateBot={setDisplayCreateBot} onBotCreate={handleBotCreate} updateSelectedBot={updateSelectedBot} />}
                {displayConnectHost && <ConnectToRemote displayConnectHost={displayConnectHost} setDisplayConnectHost={setDisplayConnectHost} onConnectHost={handleConnectHost} />}
                {serverUnresponsive && !connectionLoading ? <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", color: "white", gap: 10, fontSize: 20, textAlign: "center", marginTop: 30 }}>
                    Could not connect to server, please refresh
                    <Button onClick={() => { window.location.reload(); }} style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }}>Refresh</Button>
                </div> :
                    (loading || connectionLoading) ? <Spin size="large" style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: 120

                    }} /> :
                        <div style={{ height: "90%" }}>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 15 }}>

                                <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="61.474" viewBox="0 0 50 61.474">
                                            <g id="Group_30" data-name="Group 30" transform="translate(-43.472 -151)">
                                                <path id="Path_5804" data-name="Path 5804" d="M272.791,176.36a24.858,24.858,0,0,0-25,24.654v23.321a2.04,2.04,0,0,0,2.054,2.026h45.89a2.041,2.041,0,0,0,2.054-2.026l0-23.321a24.857,24.857,0,0,0-25-24.654ZM251.9,201.014a20.771,20.771,0,0,1,20.89-20.6,20.987,20.987,0,0,1,7.327,1.333,25.293,25.293,0,0,0-19.14,22.586,8.342,8.342,0,0,0-6.156,6H251.9Zm11.04,7.131a4.216,4.216,0,1,1-4.275,4.216A4.25,4.25,0,0,1,262.941,208.145Zm30.739,14.162H251.9v-7.919h2.92a8.4,8.4,0,0,0,16.237,0h22.62v7.919Zm0-11.972H271.059a8.338,8.338,0,0,0-5.975-5.957,21.306,21.306,0,0,1,20.84-19.363,20.456,20.456,0,0,1,7.756,16Zm-10.427-22.015a2.008,2.008,0,0,0-.062,2.865,14.042,14.042,0,0,1,4,9.828,2.054,2.054,0,0,0,4.109,0,18.043,18.043,0,0,0-5.146-12.631,2.071,2.071,0,0,0-2.9-.062Z" transform="translate(-204.318 -13.886)" fill="#8b8b8b" />
                                                <rect id="Rectangle_20" data-name="Rectangle 20" width="5" height="11" rx="2.5" transform="translate(70 155)" fill="#8b8b8b" />
                                                <rect id="Rectangle_21" data-name="Rectangle 21" width="5" height="17" rx="2.5" transform="translate(55 151)" fill="#8b8b8b" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div>
                                        <div style={{ color: "white", fontSize: 17, cursor: "default" }}>The Robolla Bot List</div>
                                        <div style={{ color: "#B4B4B4", fontSize: 13, cursor: "default" }}>Create a trading bot and set where they are hosted and their strategy.</div>
                                        <div style={{ color: "#B4B4B4", fontSize: 13, cursor: "default" }}>To start click <span style={{ textDecoration: "underline" }}>'CREATE BOT'</span> </div>

                                    </div>

                                </div>
                                <div>
                                    <Button onClick={() => { setUpdateSelectedBot(null); setDisplayCreateBot(true); }} style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">CREATE BOT</Button>
                                </div>

                            </div>
                            <div style={{ display: "flex", flexDirection: "row", height: "70%", width: "100%", padding: 10 }}>
                                <div style={{ display: "flex", flexDirection: "column", borderRadius: 5, width: "100%" }}>
                                    <div style={{ maxHeight: 800, overflowY: "auto", }}>
                                        <table style={{ width: "100%", }}>
                                            <tr>
                                                <th style={tableHeaderStyle} >NAME</th>
                                                <th style={tableHeaderStyle} >TYPE</th>
                                                <th style={tableHeaderStyle} >HOME BASE (EXCHANGE API PROFILE)</th>
                                                <th style={tableHeaderStyle} >ADVANCED</th>
                                                <th style={tableHeaderStyle} >DELETE</th>
                                                <th style={{
                                                    fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "center", paddingRight: 50

                                                }} >GO</th>
                                            </tr>
                                            {bots.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)).map(bot => <tr
                                            >
                                                <td style={tableRowStyle}>
                                                    <div>{bot.name} <span onClick={(e) => { e.stopPropagation(); setUpdateSelectedBot(bot); setDisplayCreateBot(true); }} style={{ textDecoration: "underline", cursor: "pointer" }}>(EDIT)</span> </div>
                                                    <div style={{ fontSize: 13, color: "grey" }} >{bot.description}</div>
                                                </td>
                                                <td style={tableRowStyle}>
                                                    <div>{botType[bot.type]}</div>
                                                </td>
                                                <td style={tableRowStyle}>
                                                    {bot.host.name}
                                                </td>
                                                <td style={tableRowStyle}>{bot.active ? "ACTIVE" : "INACTIVE"}</td>
                                                <td style={tableRowStyle}><span onClick={() => {
                                                    setDisplayWarning(true); setDeleteBotId(bot.id);
                                                }} style={{ textDecoration: "underline", cursor: "pointer" }}>(DELETE)</span></td>
                                                <td onClick={() => {
                                                    // setSelectedBot(bot);
                                                    // setDisplayAdvancedSection(true);

                                                }} style={{ fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "center", paddingRight: 50 }}><span onClick={() => {
                                                    setSelectedBot(bot);
                                                    setDisplayAdvancedSection(true);
                                                }} style={{ cursor: "pointer" }}><PlayCircleOutlined style={{ fontSize: 25 }} /></span></td>
                                            </tr>)}

                                        </table>
                                    </div>
                                    {bots.length === 0 && <div style={{ textAlign: "center", marginTop: 40, height: 400 }}>
                                        <img src={bot} style={{ marginBottom: 10 }} />
                                        <div style={{ color: "white" }} >THERE ARE NO BOTS HERE.</div>
                                        <div style={{ color: "white" }} >START BY CLICKING CREATE BOT BELOW</div>
                                        <Button onClick={() => { setDisplayCreateBot(true); }} style={{ backgroundColor: "#161616", color: "white", width: 150, height: 50, marginTop: 10 }} type="default">CREATE BOT</Button>

                                        {/* <div style={{ marginTop: 150 }}>
                                        <Button onClick={() => { setDisplayConnectHost(true) }} style={{ backgroundColor: "#161616", color: "white", width: 200, height: 35 }} type="default">Connect to Remote Host</Button>
                                    </div> */}
                                    </div>}
                                </div>
                            </div>
                        </div>

                }

                <div>
                </div>
            </>}

        </>
    );
};

export default Home;